import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getFaq } from '../../services';
import type { WearablesSection } from '../../types/faq';

export const useGetFaq = (): UseQueryResult<WearablesSection[], Error> => {
  return useQuery({
    queryKey: ['get_faq'],
    queryFn: getFaq,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
